export enum PromoCodeRejectionReason {
    NOTACTIVE = 1, //
    OUTSIDEOFDATES = 2, //
    OUTSIDEDAYOFUSE = 3, //
    NOREQUIREDITEMS = 4, //
    NOAPPLICATIONITEMS = 5, //
    MAXUSEREACHED = 6,
    INCORRECTTRANSACTIONTYPE = 7,
}
